<template>
  <div class="threeCon"
       :style="{'background': background}">
    <div class="three"
         v-if="device !== 'mobile'">
      <!-- 产品列表 -->
      <ul>
        <li v-for="(item, index) in manList"
            class="three-goodslist-item"
            :key="
            item.id + index"
            :class="{ 'mouse-in': mouseInIndex[0] === index, 'mouse-out': mouseOutIndex[0] === index }"
            @mouseenter="onMouseIn(index, 0)" @mouseleave="onMouseOut(index, 0)"
            @click="openPic(item)"
        >
          <div
            class="three-goodslist-item-hover"
            :style="{ 'background-image': `url(${item.fullImg})`}"
          ></div>
          <div
            class="three-goodslist-item-normal"
            :class="{'with-flip-img': item.hover }"
            :style="{ 'background-image': `url(${item.img})`}"
          ></div>
        </li>

      </ul>
      <ul>
        <li v-for="(item, index) in womanList"
            class="three-goodslist-item"
            :key="
            item.id + index"
            :class="{ 'mouse-in': mouseInIndex[1] === index, 'mouse-out': mouseOutIndex[1] === index }"
              @mouseenter="onMouseIn(index, 1)" @mouseleave="onMouseOut(index, 1)"
              @click="openPic(item)"
        >
          <div
            class="three-goodslist-item-hover"
            :style="{ 'background-image': `url(${item.fullImg})`}"
          ></div>
          <div
            class="three-goodslist-item-normal"
            :class="{'with-flip-img': item.hover }"
            :style="{ 'background-image': `url(${item.img})`}"
          ></div
            >
        </li>
      </ul>
      <ul>
        <li v-for="(item, index) in childList"
            class="three-goodslist-item"
            :key="
            item.id + index"
            :class="{ 'mouse-in': mouseInIndex[2] === index, 'mouse-out': mouseOutIndex[2] === index }"
              @mouseenter="onMouseIn(index, 2)" @mouseleave="onMouseOut(index, 2)" @click="openPic(item)"
        >
          <div
            class="three-goodslist-item-hover"
            :style="{ 'background-image': `url(${item.fullImg})`}"
          ></div>
          <div
            class="three-goodslist-item-normal"
            :class="{'with-flip-img': item.hover }"
            :style="{ 'background-image': `url(${item.img})`}"
          ></div>
        </li>
      </ul>
    </div>
    <div class="mobileThree"
         v-else
         ref="viewBox"
         :style="{'height': mobileBoxHeight, 'overflow': mobileBoxOverflow}">
      <img src="../../assets/mobile-three-women.png"
           class="three-mobile-item"
           alt=""
           :style="{ 'width': imgWidth + 'px' }"
           @click="toChild('women')">
      <img src="../../assets/mobile-three-men.png"
           class="three-mobile-item"
           alt=""
           :style="{ 'width': imgWidth + 'px' }"
           @click="toChild('men')">
      <img src="../../assets/mobile-three-child.png"
           class="three-mobile-item"
           alt=""
           :style="{ 'width': imgWidth + 'px' }"
           @click="toChild('child')">
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      :append-to-body="true"
      :width="device==='mobile'?'80%':'60%'"
      top="10vh">
        <img src="" class="dialog-img"  :style="{height:'70vh',width:'auto'}">
    </el-dialog>
  </div>
</template>
<script>
import { fetchList } from '@/api/list'
import { mapState } from 'vuex'
import { GetSlideDirection } from '../../utils/index'
var startX, startY, endX, endY
export default {
  name: 'three',
  data () {
    return {
      manList: [],
      womanList: [],
      childList: [],
      imgWidth: 0,
      mouseInIndex: [-1, -1, -1],
      mouseOutIndex: [-1, -1, -1],
      typeList: [],
      state: '',
      clientHeight: 0,
      background: '',
      scrollTop: 0,
      mobileBoxHeight: '0px',
      mobileBoxOverflow: 'hidden',
      dialogVisible: false
    }
  },
  computed: {
    ...mapState({
      device: state => state.app.device,
      fromPath: state => state.app.fromPath
    })
  },
  watch: {
    device (val) {
      if (val === 'mobile') {
        this.background = 'white'
      }
    }
  },
  beforeDestroy () {
    const that = this
    window.removeEventListener('scroll', this.handleScroll)
    document.removeEventListener('touchstart', function (event) {
      that.touchstart(event)
    })
    document.removeEventListener('touchend', function (event) {
      that.touchend(event)
    })
  },
  mounted () {
    const that = this
    this.getNavList()
    this.imgWidth = document.documentElement.clientWidth * 0.85
    this.clientHeight = document.documentElement.clientHeight - 100
    if (this.device === 'mobile') {
      this.background = 'white'
    }
    setTimeout(() => {
      if (that.device === 'mobile') {
        that.mobileBoxHeight = ''
        that.mobileBoxOverflow = 'auto'
        window.addEventListener('scroll', this.handleScroll)
        document.addEventListener('touchstart', function (event) {
          that.touchstart(event)
        })
        document.addEventListener('touchend', function (event) {
          that.touchend(event)
        })
      }
    }, 500)
  },
  methods: {
    openPic (item) {
      this.dialogVisible = true
      this.$nextTick(() => {
        const dialogImg = document.querySelector('.dialog-img')
        dialogImg.src = item.fullImg ? item.fullImg : item.img
      })
    },
    touchstart: function (event) {
      this.isTouch = true
      startX = event.touches[0].pageX
      startY = event.touches[0].pageY
    },
    touchend: function (event) {
      endX = event.changedTouches[0].pageX
      endY = event.changedTouches[0].pageY
      const state = GetSlideDirection(startX, startY, endX, endY)
      if (this.device === 'mobile' && this.$refs.viewBox) {
        if (this.$refs.viewBox.clientHeight <= document.documentElement.clientHeight) {
          if (state === 'up') {
            this.$router.push({ name: 'tale' })
          } else if (state === 'down') {
            this.$router.push({ name: 'automation' })
          }
        } else {
          if (state === 'up') {
            if (this.scrollTop + document.documentElement.clientHeight >= this.$refs.viewBox.clientHeight) {
              this.$router.push({ name: 'tale' })
            }
          } else if (state === 'down') {
            if (this.scrollTop <= 0) {
              this.$router.push({ name: 'automation' })
            }
          }
        }
      }
    },
    handleScroll () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this.scrollTop = scrollTop
    },
    toChild (type) {
      const { typeList } = this
      let id = 0
      for (const i in typeList) {
        if (type === 'women') {
          if (typeList[i].title === '女装') {
            id = typeList[i].id
          }
        } else if (type === 'men') {
          if (typeList[i].title === '男装') {
            id = typeList[i].id
          }
        } else if (type === 'child') {
          if (typeList[i].title === '童装') {
            id = typeList[i].id
          }
        }
      }
      this.$router.push({ path: '/productList', query: { openType: 'parents', id: id } })
    },
    getNavList () {
      const that = this
      const query = `
        query{
          getTypeList(
            id: -1,
            type:PRODUCT
          ){
            id,
            title
          }
        }
      `
      fetchList(query).then(response => {
        const list = response.data.data.getTypeList
        this.typeList = list
        for (const i in list) {
          if (i <= 2) {
            that.getProductList(list[i].id, i)
          }
        }
      })
    },
    getProductList (id, index) {
      const query = `
      query{
        getMotherPics(
          motherID: ${id}
        ){
            id,
            pics{
              cnPics{
                id,
                url,
                secondUrl
              }
            }
          }
        }
      `
      fetchList(query).then(response => {
        const productList = response.data.data.getMotherPics.pics.cnPics
        for (const m in productList) {
          productList[m].isLong = false
          productList[m].img = productList[m].url
          productList[m].fullImg = productList[m].secondUrl
          productList[m].hover = !!productList[m].secondUrl
        }
        if (index === '0') {
          this.manList = productList
        } else if (index === '1') {
          this.womanList = productList
        } else if (index === '2') {
          this.childList = productList
        }
      })
    },
    onMouseIn (index, i) {
      const { mouseInIndex } = this
      mouseInIndex[i] = index
      this.mouseInIndex = [...mouseInIndex]
    },
    onMouseOut (index, i) {
      const { mouseOutIndex } = this
      this.mouseInIndex = [-1, -1, -1]
      // this.mouseInIndex = -1
      mouseOutIndex[i] = index
      this.mouseOutIndex = [...mouseOutIndex]

      setTimeout(() => {
        this.mouseOutIndex = [-1, -1, -1]
      }, 300)
    },
    onTouch (index, i) {
      this.mouseOutIndex = [...this.mouseInIndex]

      const mouseInIndex = [-1, -1, -1]

      mouseInIndex[i] = this.mouseInIndex[i] === index ? -1 : index
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/Global.scss";
.threeCon {
  height: 100%;
}
.longImg {
  @include flexItem(0, 0, 0, 66.2%);
  overflow: hidden;
  position: relative;
  height: 363px;
  background-color: white;
  margin: 2px 2px 0 0;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.longImg .three-goodslist-item-img {
  width: 100%;
  height: 100%;
}
.center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) !important;
}
::-webkit-scrollbar {
  display: none;
}
.three {
  margin-left: 300px;
  height: 100%;
  background-color: #1e2441;
  overflow-y: auto;
  display: flex;
}
.three ul {
  flex: 1;
  overflow-y: auto;
}
.three ul li {
  height: 363px;
  // background-color: aquamarine;
}
.three-goodslist-item {
  overflow: hidden;
  // @include flexItem(0, 0, 0, 33%);
  // flex: 0 1 33%;
  position: relative;
  // flex: 1;
  height: 363px;
  background-color: white;
  margin: 2px 2px 0 0;
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 100%;

  &-normal {
    width: 100%;
    height: 100%;
    position: absolute;
    margin: 2px 2px 0 0;
    background-color: white;
    background-repeat: no-repeat;
    background-position: center;
    background-size: auto 100%;
  }

  &-hover {
    width: 100%;
    height: 100%;
    position: absolute;
    margin: 2px 2px 0 0;
    background-color: white;
    background-repeat: no-repeat;
    background-position: center;
    background-size: auto 100%;
  }
}

.mouse-in {
  .with-flip-img {
    animation-name: fold-left-in;
    animation-duration: 0.3s;
    animation-fill-mode: forwards;
  }
}

.mouse-out {
  .with-flip-img {
    animation-name: fold-left-out;
    animation-duration: 0.3s;
    animation-fill-mode: forwards;
  }
}

.three-goodslist-collect {
  position: absolute;
  width: 15px;
  bottom: 29px;
  left: 20px;
  z-index: 10;
}
.mobileThree {
  padding-top: 80px;
  background: white;
  .three-mobile-item {
    margin-bottom: 15px;
  }
}

@keyframes fold-left-in {
  0% {
    width: 100%;
  }
  100% {
    width: 0%;
  }
}

@keyframes fold-left-out {
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
}

.dialog-img{
  display: block;
  margin: auto;
}
.el-dialog__wrapper{
  z-index: 10000!important;
}
// .three-goodslist {
//   @include flexBox(row, row wrap, flex-start);
//   display: flex;
//   margin-top: 0px;
//   flex-wrap: wrap;
// }
// .three-goodslist-item {
//   overflow: hidden;
//   @include flexItem(0, 0, 0, 33%);
//   // flex: 0 1 33%;
//   position: relative;
//   // flex: 1;
//   height: 363px;
//   background-color: white;
//   margin: 2px 2px 0 0;
//   background-repeat: no-repeat;
//   background-position: center;
//   background-size: auto 100%;
// }
</style>
